// Phase 11a — PayoutEvent read shape (bank-agnostic per 11a-7).
// Bank/processor info captured in payload.bankProcessor.
import { z } from 'zod';
import { PayoutEventTypeSchema } from './enums.schema.js';
export const PayoutEventResponseSchema = z.object({
    id: z.string().uuid(),
    payoutId: z.string().uuid(),
    eventType: PayoutEventTypeSchema,
    amountCents: z.number().int(),
    externalRef: z.string().nullable(),
    recordedAt: z.string().datetime(),
    recordedByUserId: z.string().uuid().nullable(),
    /** Free-form JSON; expected shape includes optional
     *  `bankProcessor: 'RBC' | 'TD' | ...` per 11a-7 bank-agnostic
     *  principle so a bank switch requires zero schema migration. */
    payload: z.unknown().nullable(),
});
//# sourceMappingURL=payout-event.schema.js.map